const namespace = 'AUDITED_FINANCIALS_';

export const CONSTANTS = {
    GET_AUDITED_FINANCIALS_REPORT_ID: `${namespace}GET_AUDITED_FINANCIALS_REPORT_ID`,
    GET_AUDITED_FINANCIALS_REPORT_ID_SUCCESS: `${namespace}GET_AUDITED_FINANCIALS_REPORT_ID_SUCCESS`,
};

export const TENURE = {
    MONTHLY: 'Monthly',
    QUARTERLY: 'Quarterly',
    YEARLY: 'Yearly',
} as const;

export const HEADER_TYPE = {
    AUDITED_FINANCIALS: 'audited',
    PROVISIONAL_FINANCIALS: 'provisional',
} as const;
